import { LanguageEnum } from '@/generated/graphql.mia'
import { useUrlSearchParams } from '@vueuse/core'
import validator from 'validator'

export const defaultLanguage = LanguageEnum.En

export const useCustomParams = () => {
  const params = useUrlSearchParams('history')

  let language = defaultLanguage.toLocaleLowerCase()
  if (params.language) {
    language = params.language as string
  }

  let prompt = params.prompt as string | undefined

  let username = 'Anonymous'
  if (params.username) {
    username = params.username as string
  }

  let source = 'Unknown'
  if (params.source) {
    source = params.source as string
  }

  const email = validator.isEmail(username) ? username : null
  const user_id = email === null ? username : null

  let url = params.url as string | undefined

  return { language, prompt, username, source, email, user_id, url }
}
